import React from "react";
import { Row } from "react-bootstrap";
import { Modal } from "react-responsive-modal";
import { Strings } from "../../Translations/i18n";
import "./CustomModal.scss";
import "react-responsive-modal/styles.css";

class CustomModal extends React.Component {
  render() {
    return (
      <Modal
        open={this.props.open}
        onClose={this.props.closeModal}
        center
        closeOnEsc={this.props.modalCloseOnEsc}
        closeOnOverlayClick={this.props.modalCloseOnOverlayClick}
        showCloseIcon={false}
        classNames={{
          modal: this.props.className ? "customModal" : "customModal1",
        }}
      >
        <Row className="userModal">
          <Row className="headerModal">{Strings(this.props.headerTextId)}</Row>
          <Row className="modalContent">{this.props.children}</Row>
        </Row>
      </Modal>
    );
  }
}

export default CustomModal;
